import { useMemo, useState } from 'react';
import { ProductDeleteModalContext } from '../contexts/ProductDeleteModalContext';
import { ProductEditModalContext } from '../contexts/ProductEditModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHighlightModalsProvider = ({
  children
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const deleteModalContextValue = useMemo(() => ({
    isDeleteModalOpen,
    setIsDeleteModalOpen
  }), [isDeleteModalOpen, setIsDeleteModalOpen]);
  const editModalContextValue = useMemo(() => ({
    isEditModalOpen,
    setIsEditModalOpen
  }), [isEditModalOpen]);
  return /*#__PURE__*/_jsx(ProductEditModalContext.Provider, {
    value: editModalContextValue,
    children: /*#__PURE__*/_jsx(ProductDeleteModalContext.Provider, {
      value: deleteModalContextValue,
      children: children
    })
  });
};